import { render, staticRenderFns } from "./ParentAccountModal.vue?vue&type=template&id=107c425b&scoped=true&"
import script from "./ParentAccountModal.vue?vue&type=script&lang=js&"
export * from "./ParentAccountModal.vue?vue&type=script&lang=js&"
import style0 from "./ParentAccountModal.vue?vue&type=style&index=0&id=107c425b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107c425b",
  null
  
)

export default component.exports